export default __webpack_public_path__ + "static/media/home4.ae35d685.png";